// import Box from "@mui/material/Box";
// import Grid from "@mui/material/Grid";
// import loginbackground from "../../assets/loginbackground.png";
// import backloginfo from "../../assets/backlog.png";
// import Button from "@mui/material/Button";
// import TextField from "@mui/material/TextField";
// import Typography from "@mui/material/Typography";
// import Container from "@mui/material/Container";
// import Avatar from "@mui/material/Avatar";
// import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
// import { ThemeProvider, createTheme } from "@mui/material/styles";

// import { useState, forwardRef } from "react";
// import Snackbar from "@mui/material/Snackbar";
// import Stack from "@mui/material/Stack";
// import MuiAlert from "@mui/material/Alert";
// import Slide from "@mui/material/Slide";
// import { useNavigate } from "react-router-dom";
// import React from "react";
// import emailjs from "@emailjs/browser";

// import { useMode } from "../../theme";
// import { useMediaQuery } from "@mui/material";

// function LoginHelp() {
//   const navigate = useNavigate();

//   const [name, setName] = useState("");
//   const [message, setMessage] = useState("");
//   const [email, setEmail] = useState("");

//   const [open, setOpen] = useState(false);

//   const vertical = "top";
//   const horizontal = "right";
//   const [theme = {}, colorMode] = useMode();

//   const breakpoint = theme.breakpoints.down("md");

//   const isDown = useMediaQuery(breakpoint);
//   const Alert = forwardRef(function Alert(props, ref) {
//     return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
//   });

//   const lightTheme = createTheme({
//     palette: {
//       mode: "light",
//     },
//   });

//   const boxstyle = {
//     position: "absolute",
//     top: "50%",
//     left: "50%",
//     transform: "translate(-50%, -50%)",
//     width: "75%",
//     maxHeight: "70%",
//     bgcolor: isDown ? "" : "background.paper",
//     boxShadow: 24,
//   };

//   const center = {
//     position: "relative",
//     top: ".2rem",
//     margin: "auto",
//   };
//   const handleSubmit = async (event) => {
//     event.preventDefault();
//     setOpen(true);

//     // Prepare data to send

//     const templateParams = {
//       to_name: name,
//       from_name: email,
//       message: message,
//     };

//     emailjs
//       .send(
//         "service_z3d8jcp",
//         "template_y6ht2vz",
//         templateParams,
//         "3BSY1IeamhRh28tEG"
//       )
//       .then(
//         (response) => {},
//         (err) => {
//           console.error("FAILED...", err);
//         }
//       );

//     setName("");
//     setMessage("");
//     setEmail("");
//   };

//   const handleClose = (event, reason) => {
//     if (reason === "clickaway") {
//       return;
//     }
//     setOpen(false);
//   };

//   function TransitionLeft(props) {
//     return <Slide {...props} direction="left" />;
//   }

//   return (
//     <>
//       <Snackbar
//         open={open}
//         autoHideDuration={3000}
//         onClose={handleClose}
//         TransitionComponent={TransitionLeft}
//         anchorOrigin={{ vertical, horizontal }}
//       >
//         <Alert onClose={handleClose} severity="success" sx={{ width: "100%" }}>
//           Successfully Sent Login Report!!
//         </Alert>
//       </Snackbar>
//       <Box
//         sx={{
//           backgroundImage: `url(${loginbackground})`,
//           backgroundSize: "cover",
//           height: "100vh",
//           color: "#f5f5f5",
//         }}
//       >
//         <Box sx={boxstyle}>
//           <Grid container sx={{ maxHeight: "100%" }}>
//             {!isDown && (
//               <Grid item xs={12} sm={12} lg={6}>
//                 <Box
//                   sx={{
//                     backgroundImage: `url(${backloginfo})`,
//                     backgroundSize: "cover",

//                     height: "100%",
//                     color: "#f5f5f5",
//                   }}
//                 />
//               </Grid>
//             )}
//             <Grid item xs={12} sm={12} lg={6}>
//               <Box
//                 style={{
//                   backgroundColor: "#C0B476",
//                   padding: "1rem",
//                   maxHeight: "100%",
//                 }}
//               >
//                 <ThemeProvider theme={lightTheme}>
//                   <Container>
//                     <Box height={10} />
//                     <Box sx={center}>
//                       <Avatar
//                         sx={{
//                           ml: "85px",
//                           mb: "4px",
//                           color: "#000000",
//                           margin: "auto",
//                         }}
//                       >
//                         <LockOutlinedIcon />
//                       </Avatar>
//                       <Typography
//                         component="h1"
//                         variant="h4"
//                         sx={{ color: "black", textAlign: "center" }}
//                       >
//                         Raise a Ticket
//                       </Typography>
//                     </Box>
//                     <Box
//                       component="form"
//                       noValidate
//                       onSubmit={handleSubmit}
//                       sx={{ mt: 2, bgcolor: "white" }}
//                     >
//                       <Grid container spacing={1} sx={{ padding: "2rem" }}>
//                         <Grid item xs={12}>
//                           <TextField
//                             required
//                             fullWidth
//                             name="to_name"
//                             label="Name"
//                             type="text"
//                             id="name"
//                             autoComplete="text"
//                             value={name}
//                             onChange={(e) => setName(e.target.value)}
//                           />
//                         </Grid>
//                         <Grid item xs={12}>
//                           <TextField
//                             required
//                             fullWidth
//                             id="email"
//                             label="Email"
//                             name="from_name"
//                             autoComplete="email"
//                             value={email}
//                             onChange={(e) => setEmail(e.target.value)}
//                           />
//                         </Grid>

//                         <Grid item xs={12}>
//                           <TextField
//                             required
//                             fullWidth
//                             name="message"
//                             label="Message"
//                             type="text"
//                             id="message"
//                             value={message}
//                             autoComplete="text"
//                             onChange={(e) => setMessage(e.target.value)}
//                           />
//                         </Grid>
//                         <Grid
//                           item
//                           xs={12}
//                           sx={{
//                             textAlign: "center",
//                           }}
//                         >
//                           <Button
//                             type="submit"
//                             variant="contained"
//                             sx={{
//                               borderRadius: 28,
//                               color: "#ffffff",
//                               padding: ".5rem 3rem",
//                               backgroundColor: "#FF9A01",
//                             }}
//                           >
//                             Submit
//                           </Button>
//                         </Grid>
//                         <Grid
//                           item
//                           xs={12}
//                           sx={{
//                             textAlign: "center",
//                           }}
//                         >
//                           <Stack direction="row" spacing={2}>
//                             <Typography
//                               variant="body1"
//                               component="span"
//                               style={{ marginTop: "10px", color: "black" }}
//                             >
//                               Already have an Account?{" "}
//                               <span
//                                 style={{ color: "orange", cursor: "pointer" }}
//                                 onClick={() => {
//                                   navigate("/login");
//                                 }}
//                               >
//                                 Sign In
//                               </span>
//                             </Typography>
//                           </Stack>
//                         </Grid>
//                       </Grid>
//                     </Box>
//                   </Container>
//                 </ThemeProvider>
//               </Box>
//             </Grid>
//           </Grid>
//         </Box>
//       </Box>
//     </>
//   );
// }

// export default LoginHelp;

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import loginbackground from "../../assets/loginbackground.png";
import backloginfo from "../../assets/backlog.png";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { useState, forwardRef } from "react";
import Snackbar from "@mui/material/Snackbar";
import Stack from "@mui/material/Stack";
import MuiAlert from "@mui/material/Alert";
import Slide from "@mui/material/Slide";
import { useNavigate } from "react-router-dom";
import React from "react";
import emailjs from "@emailjs/browser";
import { useMode } from "../../theme";
import { useMediaQuery } from "@mui/material";

function LoginHelp() {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [message, setMessage] = useState("");
  const [email, setEmail] = useState("");
  const [open, setOpen] = useState(false);
  const [errors, setErrors] = useState({ name: "", email: "", message: "" });
  const [theme = {}, colorMode] = useMode();
  const isDown = useMediaQuery(theme.breakpoints.down("md"));
  const vertical = "top";
  const horizontal = "right";

  const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  const lightTheme = createTheme({
    palette: {
      mode: "light",
    },
  });

  const boxstyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "75%",
    maxHeight: "70%",
    bgcolor: isDown ? "" : "background.paper",
    boxShadow: 24,
  };

  const center = {
    position: "relative",
    top: ".2rem",
    margin: "auto",
  };

  const validateForm = () => {
    const newErrors = { name: "", email: "", message: "" };
    let isValid = true;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!name || name.trim().length < 3) {
      newErrors.name = "Name must be at least 3 characters";
      isValid = false;
    }

    if (!email || !emailRegex.test(email)) {
      newErrors.email = "Valid email is required";
      isValid = false;
    }

    if (!message || message.trim().length < 10) {
      newErrors.message = "Message must be at least 10 characters";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!validateForm()) {
      return;
    }

    const templateParams = {
      to_name: name,
      from_name: email,
      message: message,
    };

    try {
      const response = await emailjs.send(
        "service_z3d8jcp",
        "template_y6ht2vz",
        templateParams,
        "3BSY1IeamhRh28tEG"
      );
      if (response.status === 200) {
        setOpen(true);
        setName("");
        setMessage("");
        setEmail("");
        setErrors({ name: "", email: "", message: "" });
      }
    } catch (err) {
      console.error("Failed to send email:", err);
    }
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  function TransitionLeft(props) {
    return <Slide {...props} direction="left" />;
  }

  return (
    <>
      <Snackbar
        open={open}
        autoHideDuration={3000}
        onClose={handleClose}
        TransitionComponent={TransitionLeft}
        anchorOrigin={{ vertical, horizontal }}
      >
        <Alert onClose={handleClose} severity="success" sx={{ width: "100%" }}>
          Successfully Sent Login Report!
        </Alert>
      </Snackbar>
      <Box
        sx={{
          backgroundImage: `url(${loginbackground})`,
          backgroundSize: "cover",
          height: "100vh",
          color: "#f5f5f5",
        }}
      >
        <Box sx={boxstyle}>
          <Grid container sx={{ maxHeight: "100%" }}>
            {!isDown && (
              <Grid item xs={12} sm={12} lg={6}>
                <Box
                  sx={{
                    backgroundImage: `url(${backloginfo})`,
                    backgroundSize: "cover",
                    height: "100%",
                    color: "#f5f5f5",
                  }}
                />
              </Grid>
            )}
            <Grid item xs={12} sm={12} lg={6}>
              <Box
                sx={{
                  backgroundColor: "#C0B476",
                  padding: "1rem",
                  maxHeight: "100%",
                }}
              >
                <ThemeProvider theme={lightTheme}>
                  <Container>
                    <Box height={10} />
                    <Box sx={center}>
                      <Avatar
                        sx={{
                          margin: "auto",
                          mb: "4px",
                          color: "#000000",
                        }}
                      >
                        <LockOutlinedIcon />
                      </Avatar>
                      <Typography
                        component="h1"
                        variant="h4"
                        sx={{ color: "black", textAlign: "center" }}
                      >
                        Raise a Ticket
                      </Typography>
                    </Box>
                    <Box
                      component="form"
                      noValidate
                      onSubmit={handleSubmit}
                      sx={{ mt: 2, bgcolor: "white" }}
                    >
                      <Grid container spacing={1} sx={{ padding: "2rem" }}>
                        <Grid item xs={12}>
                          <TextField
                            required
                            fullWidth
                            name="to_name"
                            label="Name"
                            type="text"
                            id="name"
                            autoComplete="name"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            error={!!errors.name}
                            helperText={errors.name}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            required
                            fullWidth
                            id="email"
                            label="Email"
                            name="from_name"
                            autoComplete="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            error={!!errors.email}
                            helperText={errors.email}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            required
                            fullWidth
                            name="message"
                            label="Message"
                            type="text"
                            id="message"
                            value={message}
                            autoComplete="off"
                            onChange={(e) => setMessage(e.target.value)}
                            error={!!errors.message}
                            helperText={errors.message}
                          />
                        </Grid>
                        <Grid item xs={12} sx={{ textAlign: "center" }}>
                          <Button
                            type="submit"
                            variant="contained"
                            sx={{
                              borderRadius: 28,
                              color: "#ffffff",
                              padding: ".5rem 3rem",
                              backgroundColor: "#FF9A01",
                            }}
                          >
                            Submit
                          </Button>
                        </Grid>
                        <Grid item xs={12} sx={{ textAlign: "center" }}>
                          <Stack direction="row" spacing={2} justifyContent="center">
                            <Typography
                              variant="body1"
                              component="span"
                              sx={{ mt: "10px", color: "black" }}
                            >
                              Already have an Account?{" "}
                              <span
                                style={{ color: "orange", cursor: "pointer" }}
                                onClick={() => navigate("/login")}
                              >
                                Sign In
                              </span>
                            </Typography>
                          </Stack>
                        </Grid>
                      </Grid>
                    </Box>
                  </Container>
                </ThemeProvider>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
}

export default LoginHelp;